import { Container } from "react-bootstrap";
import "./Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="watchtower-footer">
      <Container>
        <div className="watchtower-footer-inner">
          <span className="watchtower-footer-copyright">© {year} Guide2Property</span>
          <div className="watchtower-footer-right">
            <a
              href="https://colibry.ai/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="watchtower-footer-link"
            >
              Privacy Policy
            </a>
            <a
              href="https://colibry.ai/terms-of-use/"
              target="_blank"
              rel="noopener noreferrer"
              className="watchtower-footer-link"
            >
              Terms of Use
            </a>
            <a
              href="https://colibry.ai/wp-content/uploads/2025/03/Terms-Conditions-Co-libry-2022-1.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="watchtower-footer-link"
            >
              Terms &amp; Conditions
            </a>
            <a
              href="https://www.facebook.com/colibrybe"
              target="_blank"
              rel="noopener noreferrer"
              className="watchtower-footer-social"
              aria-label="Facebook"
            >
              <i className="bi bi-facebook" />
            </a>
            <a
              href="https://www.linkedin.com/company/co-libry/"
              target="_blank"
              rel="noopener noreferrer"
              className="watchtower-footer-social"
              aria-label="LinkedIn"
            >
              <i className="bi bi-linkedin" />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
